// グラフ設定パネルコンポーネント

import { graphRegistry } from './GraphRegistry';
import { GraphTypeSelector } from './GraphTypeSelector';
import { GraphConfig, AspectRatioPreset } from '../../../types/graph-builder.types';
import type { DataSet } from '../../../types/dataset.types';
import * as styles from '../../styles/components/graph-builder.css.ts';

/** アスペクト比の選択肢 */
const ASPECT_RATIO_OPTIONS: Array<{ value: AspectRatioPreset; label: string }> = [
  { value: '16:9', label: '16:9 (Wide)' },
  { value: '4:3', label: '4:3' },
  { value: '1:1', label: '1:1 (Square)' },
  { value: '3:4', label: '3:4' },
  { value: '9:16', label: '9:16 (Tall)' },
  { value: 'custom', label: 'Custom' },
];

interface GraphSettingsProps {
  graphType?: string;
  config?: GraphConfig;
  dataset?: DataSet;
  graphTypes: Array<{ value: string; label: string; description?: string }>;
  aspectRatio?: AspectRatioPreset;
  onGraphTypeChange: (type: string) => void;
  onConfigChange: (config: GraphConfig) => void;
  onAspectRatioChange?: (ratio: AspectRatioPreset) => void;
}

export function GraphSettings({
  graphType,
  config,
  dataset,
  graphTypes,
  aspectRatio = '16:9',
  onGraphTypeChange,
  onConfigChange,
  onAspectRatioChange
}: GraphSettingsProps) {
  // 設定UIのレンダリング
  const renderConfigUI = () => {
    if (!graphType || !config || !dataset) {
      return null;
    }

    const entry = graphRegistry.get(graphType);
    if (!entry) {
      return null;
    }

    const ConfigComponent = entry.configComponent;
    return (
      <div className={styles.settingsSection}>
        <ConfigComponent
          config={config}
          dataset={dataset}
          onChange={onConfigChange}
        />
      </div>
    );
  };

  return (
    <>
      {/* グラフタイプ選択 - カード形式 */}
      <GraphTypeSelector
        graphTypes={graphTypes}
        selectedType={graphType}
        onSelect={onGraphTypeChange}
      />

      {/* アスペクト比設定 - グラフタイプ選択後に表示 */}
      {graphType && (
        <div className={styles.settingsSection}>
          <label className={styles.configLabel}>Aspect Ratio</label>
          <select
            className={styles.select}
            value={aspectRatio}
            onChange={(e) => onAspectRatioChange?.(e.target.value as AspectRatioPreset)}
          >
            {ASPECT_RATIO_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* グラフタイプ別の設定UI */}
      {renderConfigUI()}
    </>
  );
}